<template>
    <button
        class="h-8 flex py-2 max-mb:pr-2 pr-3 pl-2 items-center gap-x-2 bg-white-300 dark:bg-blue-780 dark:hover:bg-blue-770 rounded-custom border border-gray-100 dark:border-blue-760 cursor-pointer transition-colors"
        @click="handleAssistant"
    >
        <AiIcon16x16 />

        <span class="max-mb:hidden text-xs text-gray-370 dark:text-white">
            Ask Assistant
        </span>
    </button>

    <AiAssistant v-model="appStore.aiAgentOpen" />
</template>

<script setup>
import { onBeforeUnmount, watch } from 'vue'

import AiAssistant from '@/components/ai/AiAssistant.vue'
import AiIcon16x16 from '@/components/icons/AI/AiIcon16x16.vue'

import { showHideLiveChat } from '@/helpers/app-helper'

import { useAppStore } from '@/store/appStore'

const appStore = useAppStore()

function handleAssistant() {
    appStore.toggleAiAgent()
}

watch(() => [appStore.aiAgentOpen, appStore.aiAgentOnWindow], ([value, onWindow]) => {
    if (!window.dashly) {
        return
    }

    const root = document.getElementsByTagName('html')[0]

    if (value && !onWindow) {
        root.classList.add('ai-chat-open')
    } else {
        root.classList.remove('ai-chat-open')
    }
})

onBeforeUnmount(() => {
    showHideLiveChat(false)
})
</script>
